import { chatList, chatStatus, chatScroll, nextChatPage } from "./chat";
import { dialogueStatus } from "./dialogue";

const {
  mixins: mobileChatScrollMixins,
  initScrollParams: mobileInitScrollParams,
  scrollStatus: mobileScrollStatus,
  scrollToBottom: mobileScrollToBottom,
  scrollToTop: mobileScrollToTop,
} = chatScroll(
  { chatList, chatStatus, dialogueStatus, nextChatPage },
  "#index-chat-list-scroll-view .uni-scroll-view .uni-scroll-view"
);

const {
  mixins: pcChatScrollMixins,
  initScrollParams: pcInitScrollParams,
  scrollStatus: pcScrollStatus,
  scrollToBottom: pcScrollToBottom,
  scrollToTop: pcScrollToTop,
} = chatScroll(
  { chatList, chatStatus, dialogueStatus, nextChatPage },
  "#chat_home_main"
);

export {
  mobileChatScrollMixins,
  mobileInitScrollParams,
  mobileScrollStatus,
  mobileScrollToBottom,
  mobileScrollToTop,
  pcChatScrollMixins,
  pcInitScrollParams,
  pcScrollStatus,
  pcScrollToBottom,
  pcScrollToTop,
};
